import { useInProgressIssue } from '../in-progress-issue/index.tsx';
import { useIssueRestoreMeta } from '../issue-restore-meta/index.tsx';

export const useHasRestoreFailed = (): boolean => {
	const [{ restoreError }] = useInProgressIssue();
	const [{ restoreMetaError }] = useIssueRestoreMeta();

	return Boolean(restoreError || restoreMetaError);
};
